import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";
import TeamCreationModal from "../equipo/TeamCreationModal";
import { useToast } from "../toast/ToastContext";

function TeamCoordinatorDashboard({cards, data}) {
  const [showModal, setShowModal] = useState(false);
  const [teamId, setTeamId] = useState(data.user.membership.team_member?.team_id);
  const showToast = useToast();

  function hideModal() {
    setShowModal(false);
  }

  function showTeamLink(newTeamId) {
    setTeamId(newTeamId);
    setShowModal(false);
    showToast({
      message: 'Se creó el equipo correctamente.',
      bg: 'success',
      autohide: true,
      delay: 7000,
      title: 'Equipo creado'
    });
  }

  return <Container className="dashboard p-4">
  <Row>
    <Col md={8}>
        <h2>Bienvenido</h2>
        <Row>
          {cards.map((card, idx) => {
            return <Col md={6} key={'card-' + idx}>
              <Card>
                <Card.Header>{card.title}</Card.Header>
                <Card.Body>{card.content}</Card.Body>
                <Card.Footer>{card.footer}</Card.Footer>
              </Card>
            </Col>
          })}
        </Row>
    </Col>
    <Col md={4}>
      <Card>
        <Card.Header>Acciones</Card.Header>
        <Card.Body>
          <Row className="mb-3"><Link to={'/app/user'}>Editar mi perfil</Link></Row>
          {!!teamId && <Row><Button as="a" href={`/app/org/teams/${teamId}`}>Ver Equipo</Button></Row>}
          {!teamId && <Row><Button as="a" onClick={e => setShowModal(true)}>Crear Equipo</Button></Row>}
        </Card.Body>
      </Card>
    </Col>
  </Row>
  <TeamCreationModal
      show={!!showModal} 
      handleClose={hideModal} 
      comunidadId={data.user.membership.comunidad_id}
      etapaId={data.user.membership.etapa_id}
      onSuccess={showTeamLink}
      user={data.user}
  />
</Container>
}

export default TeamCoordinatorDashboard;
